import { Icon } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
const CloseIcon = ({ onClick }) => (React.createElement(Icon, { className: "co-cross co-text-filter-close", iconName: "cross", onClick: onClick }));
export default CloseIcon;
